import { render } from "./admin-dashboard-modal.vue?vue&type=template&id=e3b75874"
import script from "./admin-dashboard-modal.vue?vue&type=script&lang=js"
export * from "./admin-dashboard-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__